import React from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { Box, Button, Highlight, Icon } from '@node-space/ui-components'
import {
  DASHBOARD_CARD_VISUAL_TYPES,
  type DashboardCardVisualType,
} from 'pages/EmbeddedCustomers/helpers/types'

interface DashboardCardProps {
  title: string
  onClick: (step: string) => void
  step?: string
  queue: string
  type: DashboardCardVisualType
  isActive: boolean
  testId?: string
}

export const DashboardCard = ({
  title,
  step,
  onClick,
  queue,
  type = DASHBOARD_CARD_VISUAL_TYPES.NEUTRAL,
  isActive = false,
  testId = 'dashboard-card',
}: DashboardCardProps) => {
  const { t } = useTranslation()

  return (
    <Box
      className={clsx(
        'flex min-h-[220px] w-full flex-1 basis-0 flex-col gap-y-4 gap-x-6 justify-between items-start self-stretch select-none rounded-xl border py-4 px-6 hover:shadow-lg cursor-pointer',
        isActive ? 'border-stroke-interactive-active' : 'border-stroke-interactive'
      )}
      onClick={() => step && onClick(step)}
      data-testid={testId}
    >
      <Box
        className={clsx(
          'w-full',
          type === DASHBOARD_CARD_VISUAL_TYPES.SUCCESS
            ? 'text-foreground-status-success'
            : 'text-foreground-prominent'
        )}
      >
        {step && type !== DASHBOARD_CARD_VISUAL_TYPES.SUCCESS && (
          <p className={clsx('text-body-regular-small')}>
            {t('embeddedCustomers.dashboard.step')} {step}
          </p>
        )}
        <Box className="flex gap-2 pb-4">
          {type === DASHBOARD_CARD_VISUAL_TYPES.SUCCESS ? (
            <Highlight variant="emphasis" type="success">
              {title}
            </Highlight>
          ) : (
            <p className={clsx('text-label')}>{title}</p>
          )}
          <Button
            variant="ghost"
            className="items-baseline"
            style={{ height: 0 }}
            iconElement={<Icon name="Info" size="medium" />}
          />
        </Box>
        {type !== DASHBOARD_CARD_VISUAL_TYPES.SUCCESS && (
          <div className={clsx('h-px w-full', 'bg-stroke-static')} />
        )}
      </Box>
      <Box
        className={clsx(
          type === DASHBOARD_CARD_VISUAL_TYPES.SUCCESS
            ? 'text-foreground-status-success'
            : 'text-foreground-prominent'
        )}
      >
        {type !== DASHBOARD_CARD_VISUAL_TYPES.SUCCESS && (
          <p className={clsx('text-body-regular')}>{t('embeddedCustomers.dashboard.queue')}</p>
        )}
        <h3 className={clsx('text-h3', 'text-foreground-subdued')}>
          {queue} {t('embeddedCustomers.dashboard.customers')}
        </h3>
      </Box>
    </Box>
  )
}
